module.exports = "/images/slide-qs-t-7.jpg";